import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Form } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import {
    IconButton,
    InputAdornment,
    Dialog,
    Grid,
    Button
} from '@material-ui/core';
import { DialogTitle, DialogContent, DialogActions } from '../Dialog/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import { TextField } from 'mui-rff';
import { simTrackingRegister } from '../../../store/actions/vehicleActionCreator';
import { getTripDetailsV3,getJourneyDetails } from '../../../store/actions/tripActionCreator';
import * as logger from '../../../logger';
import CheckApprovalDialog from '../../pages/SimTracking/CheckApproval';

const useStyles = makeStyles((theme) => ({
    title: {
        color: '#9ea0a5',
        fontSize: 12
    },
    textV1: {
        marginTop: 6,
        width: '100%',
        "& .MuiOutlinedInput-input": {
            textTransform: 'capitalize',
        },
    },
    marginV2: {
        marginTop: 16
    },
    marginV1: {
        marginTop: 6,
        width: '100%'
    },
    brV1: {
        borderRadius: 8
    },
    disableCta: {
        padding: '9px 26px 11px 28px',
        borderRadius: 4,
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
        backgroundColor: '#f1f1f3',
        fontSize: 14,
        fontWeight: 'bold',
        color: '#3e3f42',
        height: 36,
        textTransform: 'capitalize',
        letterSpacing: '0.02em'
    },
    saveCta: {
        padding: '9px 26px 11px 28px',
        borderRadius: 4,
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
        backgroundColor: '#0033cc',
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
        height: 36,
        textTransform: 'capitalize',
        letterSpacing: '0.02em',
        '&:hover': {
            backgroundColor: '#0033cc',
        }
    },
    divV1: {
        backgroundColor: '#f1f1f3',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderRadius: 8
    },
    vehicleNumberV1: {
        fontWeight: 300,
        '&:last-child': {
            color: '#0033cc',
            marginLeft: 4
        }
    },
    divV2: {
        marginTop: 8,
        fontSize: 15
    },
    titleV1: {
        color: 'grey',
        letterSpacing: '0.03em',
        fontSize: 12
    },
    paperW1: {
        maxWidth: 460,
    },
    divValidation: {
        backgroundColor: '#fdf5f6', color: '#f40000', border: '1px solid #f40000', borderRadius: 4, paddingTop: 8, paddingBottom: 8, paddingLeft: 10, paddingRight: 9, marginTop: 10
    },
    fwBold: {
        fontWeight: 300
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(2.0)",
        color: "#0033cc"
    },
}));

const DriverDetails = ({ user, open, onClose, dispatchSimTracking, dispatchTripDetailsAction }) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [dataFlag, setDataFlag] = useState(false);
    const [mobileNumberError, setMobileNumberError] = useState(false);
    const [change, setChange] = useState(false);
    const [checkForApprovalDialog, setCheckForApprovalDialog] = useState(false);
    const [staticStatus, setStaticStatus] = useState(false);
    const [consentPending, setConsentPending] = useState(false);
    const [locationPollingStatus, setLocationPollingStatus] = useState(false);

    const classes = useStyles();

    let vehicleNumber = user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.vehicleNumArrayDweb ? user.singleTripData.vehicle.vehicleNumArrayDweb : [];
    let vehicleBodyType = user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.vehicleBodyType ? user.singleTripData.vehicle.vehicleBodyType : ""
    let vehicle = user && user.singleTripData && user.singleTripData.vehicle ? user.singleTripData.vehicle : ""
    let driver = user && user.singleTripData && user.singleTripData.driver ? user.singleTripData.driver : ""
    const initialValues = {
        name: driver && driver.driverName ? driver.driverName : '',
        mobile: driver && driver.driverNumber ? (driver.driverNumber).replace(/(\d{5})(\d{5})/, "$1-$2") : ''
    }

    const getFormFields = (values) => [
        {
            size: 12,
            visible: true,
            field: (
                <>
                    <div className={classes.divV1}>
                        <div className={classes.titleV1}>Truck Information</div>
                        <div className={classes.divV2}>
                            {vehicleNumber.map((vnumber, index) => (
                                <span key={index} className={classes.vehicleNumberV1}>{vnumber}</span>
                            ))
                            }
                            {vehicle && vehicle.type && vehicle.type != "Other" &&
                                <>
                                    <span className={classes.bullet}>•</span>
                                    <span className={classes.fwBold}>{vehicle.type}</span>
                                </>
                            }
                            {vehicleBodyType &&
                                <>
                                    <span className={classes.bullet}>•</span>
                                    <span className={classes.fwBold}>{vehicleBodyType}</span>
                                </>
                            }
                        </div>
                    </div>
                </>
            )
        },
        {
            size: 12,
            visible: true,
            field: (
                <>
                    <div className={classes.marginV2}>
                        <div className={classes.title}>Driver Name</div>
                        <TextField
                            placeholder="Enter Driver Name"
                            name="name"
                            variant="outlined"
                            size="small"
                            onBlur={(e) => {
                                if (e.target.value && (e.target.value).length) {
                                    setChange(true)
                                }
                            }}
                            fieldProps={{
                                parse: value => value && (value.trim()).length == 0 ? value.trim() : value
                            }}
                            className={classes.textV1}
                        />
                    </div>
                </>
            )
        },
        {
            size: 12,
            visible: true,
            field: (
                <>
                    <div className={classes.marginV2}>
                        <div className={classes.title}>Mobile Number</div>
                        <TextField
                            placeholder="Enter Mobile Number"
                            name="mobile"
                            variant="outlined"
                            size="small"
                            // onChange={() => setDataFlag(true)}
                            // onBlur={() => setChange(true)}
                            fieldProps={{
                                parse: value => value ? (value.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : ""
                            }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">+91</InputAdornment>
                            }}
                            className={classes.marginV1}
                        />
                    </div>
                </>
            )
        },
        {
            size: 12,
            visible: true,
            field: (
                <>
                    <div className={classes.marginV2}>
                        <div className={classes.title}>We will send an SMS to the driver , requesting permission to track his mobile number/SIM card</div>
                    </div>
                </>
            )
        },
        {
            size: 12,
            visible: mobileNumberError,
            field: (
                <>
                    <div className={classes.divValidation}>
                        Enter valid <span className={classes.fwBold}>Mobile Number</span> manually to continue Tracking.
                    </div>
                </>
            )
        }
    ]

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const validate = values => {

        const errors = {}

        let driverName = values.name ? /^[A-Za-z0-9]+$/.test(values.name.replace(/\s+/g, '')) : "";
        let number = values.mobile ? /^[5-9]{1}[0-9]{9}$/.test(values.mobile.replace("-", "")) : "";

        if (!driverName) {
            errors.name = "Please enter valid name."
        }

        if (!number && change) {
            setMobileNumberError(true);
        }
        else {
            setMobileNumberError(false);
        }

        if (driverName && number) {
            setDataFlag(false);
        } else {
            setDataFlag(true);
        }

        return errors;

    }

    const onSubmit = values => {

        let driverNameArray = values && values.name ? values.name.split(" ") : [];
        let driverNameCapitalize = [];

        if (driverNameArray && driverNameArray.length > 0) {
            driverNameArray.forEach((value) => {
                if (value) {
                    driverNameCapitalize.push((value.charAt(0).toUpperCase()) + value.slice(1));
                }
            })
        }
        let journey = user && user.singleTripData && user.singleTripData.id ? user.singleTripData : null
        let tripId  = journey&&journey.trips&&journey.trips.length>0 && journey.trips[0] && journey.trips[0].id?journey.trips[0].id:''
        let simData = {
            driverName: driverNameCapitalize && driverNameCapitalize.length > 0 ? (driverNameCapitalize.join(" ")).trim() : "",
            driverNumber: (values.mobile).replace("-", ""),
            tripId: tripId
        }

        dispatchSimTracking(
            simData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Driver Detail Dialog Dweb", "Updated driver details successfully");
                    dispatchTripDetailsAction(user && user.singleTripData && user.singleTripData.id ? user.singleTripData.id : null,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log('DriverDetails Dialog Dweb', 'Get Trip details successfull');
                                if (data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.trackingStatus && data.response.vehicle.tracking.trackingStatus == "consent_pending") {
                                    setConsentPending(true);
                                    setStaticStatus(false);
                                    setLocationPollingStatus(false);
                                    setCheckForApprovalDialog(true);
                                } else if (data.response  && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.trackingStatus && data.response.vehicle.tracking.trackingStatus == "static") {
                                    setStaticStatus(true);
                                    setConsentPending(false);
                                    setLocationPollingStatus(false);
                                    setCheckForApprovalDialog(true);
                                } else if (data && data.response  && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.trackingStatus == "location_polling") {
                                    if (data && data.response && data.response.vehicle.tracking && (!data.response.vehicle.tracking.locationPoints || data.response.vehicle.tracking.locationPoints && data.response.vehicle.tracking.locationPoints.length == 0)) {
                                        setConsentPending(false);
                                        setStaticStatus(false);
                                        setLocationPollingStatus(true);
                                        setCheckForApprovalDialog(true);
                                    } else if (data && data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.locationPoints && data.response.vehicle.tracking.locationPoints.length > 0) {
                                        setConsentPending(false);
                                        setStaticStatus(false);
                                        setLocationPollingStatus(false);
                                        setCheckForApprovalDialog(false);
                                    }
                                }
                                setDialogOpen(false);
                            }
                        },
                        () => {
                            logger.log('DriverDetails Dialog Dweb', 'Get Trip details failed');
                        }
                    );
                    // onClose();
                    // if (data && data.response && data.response.status == "consent_pending") {

                    // }
                }
            },
            () => {
                logger.log("Driver Detail Dialog Dweb", "Updated driver details failed");
            }
        )

    }

    const handleApprovalDialogClose = () => {
        setCheckForApprovalDialog(false);
        onClose('fromCheckApproval');
    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-details-dialog" open={dialogOpen}
                classes={{ paperScrollPaper: classes.brV1, paperWidthXs: classes.paperW1 }}
            >
                <DialogTitle id="add-driver-details-dialog-title" onClose={handleClose}>
                    Add Driver Details
                </DialogTitle>
                <DialogContent dividers>
                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        // id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
                        Close
                    </Button>
                    <Button
                        className={dataFlag ? classes.disableCta : classes.saveCta}
                        type="submit" variant="contained"

                        // onClick={() => {
                        //     document.getElementById('myForm')
                        //         .dispatchEvent(new Event('submit', { cancelable: true }))
                        // }}
                        onClick={event => {
                            submit(event)
                        }}
                        disabled={dataFlag}
                    >
                        Save changes
                    </Button>
                </DialogActions>
            </Dialog>
            {checkForApprovalDialog && <CheckApprovalDialog open={checkForApprovalDialog} onClose={handleApprovalDialogClose} staticValue={staticStatus} consentPendingValue={consentPending} locationPollingValue={locationPollingStatus} />}
        </>
    )

}

const mapStateToProps = (state) => ({ user: state.user });
const mapDispatchToProps = (dispatch) => ({
    dispatchSimTracking: (data, onSuccess, onFailure) => {
        dispatch(simTrackingRegister(data, onSuccess, onFailure))
    },
    dispatchTripDetailsAction: (tripId, onSuccess, onError) => {
        dispatch(getJourneyDetails(tripId, onSuccess, onError))
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(DriverDetails);